angular.module('app.supplyChain')

.service('scorecardServ', function($http, URLS, FIRST_VIEW) {
	var urlPfx = '2/factndx/';

	return {
		getScorecardData: getScorecardData,
		getScorecardDataBySupplierCode: getScorecardDataBySupplierCode,
		getInitiativesData: getInitiativesData,
		getSuppliersList: getSuppliersList,
		getConfig: getConfig,
		updateConfig: updateConfig,
		saveScar: saveScar,
		deleteScar: deleteScar,
		sendEmail: sendEmail,
		getSupplierInfo: getSupplierInfo,
		getMultiSite: getMultiSite,
		getErpOrderPolicyData: getErpOrderPolicyData
	};

	function sendEmail(supplierNdx, showAllSites, factoryNdx) {
		var url = URLS.host + urlPfx + (factoryNdx || globalConfig.factory.id) + '/EmailRequest/type/supplierScorecardImmediate/event/' + supplierNdx;
		if (showAllSites) {
			url += '?allFactories=true';
		}
		return $http.put(url)
			.then(sendEmailSuccess)
			.catch(sendEmailFailed);

		function sendEmailSuccess(response) {
			return response;
		}

		function sendEmailFailed(error) {
			return error;
		}
	}

	function getMultiSite() {
		var url = URLS.host + '2/Dimensions/Factories?opsFactNdx=' + globalConfig.factory.id;
		return $http.get(url)
			.then(getMultiSiteComplete)
			.catch(getMultiSiteError);

		function getMultiSiteComplete(response) {
			return response.data;
		}

		function getMultiSiteError(error) {
			return error;
		}
	}

	function getErpOrderPolicyData(factoryNdx) {
		var url = String.format(URLS.erpOrderPolicies, (factoryNdx || globalConfig.factory.id));
		return $http.get(URLS.host + url)
			.then(getErpOrderPolicyDataComplete)
			.catch(getErpOrderPolicyDataFailed);

		function getErpOrderPolicyDataComplete(response) {
			return response.data;
		}

		function getErpOrderPolicyDataFailed(error) {
			return [];
		}
	}

	function getSupplierInfo() {
		var url = URLS.host + urlPfx + globalConfig.factory.id + '/SupplierScorecard/SupplierInfo';
		return $http.get(url)
			.then(getSupplierInfoComplete)
			.catch(getSupplierInfoFailed);

		function getSupplierInfoComplete(response) {
			return response.data;
		}

		function getSupplierInfoFailed(error) {
			return error;
		}
	}

	function saveScar(content, supplierNdx) {
		var url = URLS.host + urlPfx + globalConfig.factory.id + '/SupplierScorecard/Supplier/' + supplierNdx + '/Scars';
		var contentType = {
			headers: {
				'Content-Type': 'application/text'
			}
		};
		return $http.put(url, content, contentType)
			.then(saveScarComplete)
			.catch(saveScarFailed);

		function saveScarComplete(response) {
			return response;
		}

		function saveScarFailed(error) {
			return undefined;
		}

	}

	function deleteScar(supplierNdx) {
		var url = URLS.host + urlPfx + globalConfig.factory.id + '/SupplierScorecard/Supplier/' + supplierNdx + '/Scars/';
		return $http.delete(url)
			.then(deleteScarComplete)
			.catch(deleteScarFailed);

		function deleteScarComplete(response) {
			return response;
		}

		function deleteScarFailed(error) {
			return undefined;
		}
	}

	function getScorecardData(supplierNdx, showAllSites, factoryNdx) {
		var url = URLS.host + urlPfx + (factoryNdx || globalConfig.factory.id) + '/SupplierScorecard/Supplier/' + supplierNdx;
		if (showAllSites) {
			url += '?allFactories=true';
		}
		return $http.get(url)
			.then(getScorecardDataComplete)
			.catch(getScorecardDataFailed);

		function getScorecardDataComplete(response) {
			return response.data;
		}

		function getScorecardDataFailed(error) {
			return undefined;
		}
	}

	function getScorecardDataBySupplierCode(supplierCode, sites, supplierNdxs) {
		var url = URLS.host + urlPfx + globalConfig.factory.id + '/SupplierScorecard/sites/' + sites + '/SupplierCode/?supplierCode=' + supplierCode;
		if (supplierNdxs) {
			url += '&supplierNdxs=' + supplierNdxs;
		}
		return $http.get(url)
			.then(getScorecardDataBySupplierCodeComplete)
			.catch(getScorecardDataBySupplierCodeFailed);

		function getScorecardDataBySupplierCodeComplete(response) {
			return response.data;
		}

		function getScorecardDataBySupplierCodeFailed(error) {
			return undefined;
		}
	}

	function getInitiativesData(supplierNdx, showAllSites) {
		var url = URLS.host + urlPfx + globalConfig.factory.id + '/SupplierInitiatives/Supplier/' + supplierNdx;
		if (showAllSites) {
			url = url + '?allFactories=true';
		}
		return $http.get(url)
			.then(getInitiativesDataComplete)
			.catch(getInitiativesDataFailed);

		function getInitiativesDataComplete(response) {
			return response.data;
		}

		function getInitiativesDataFailed(error) {
			return undefined;
		}
	}

	function getSuppliersList() {
		var url = URLS.host + String.format(URLS.suppliers, globalConfig.factory.id);
		return $http.get(url)
			.then(getSuppliersListComplete)
			.catch(getSuppliersListFailed);

		function getSuppliersListComplete(response) {
			return response.data;
		}

		function getSuppliersListFailed(error) {
			return undefined;
		}
	}

	function getConfig(reportName) {
		reportName = reportName || 'SupplierScorecard';
		return $http.get(URLS.host + urlPfx + globalConfig.factory.id + '/ReportSettings/' + reportName + '?viewType=scorecard')
			.then(getConfigComplete)
			.catch(getConfigFailed);

		function getConfigComplete(response) {
			return response.data;
		}

		function getConfigFailed(error) {
			return undefined;
		}
	}

	function updateConfig(config) {
		config.config = config.config || {};
		config.reportName = config.reportName || 'SupplierScorecard';
		config.baseReportName = config.baseReportName || 'SupplierScorecard';
		config.viewType = config.viewType || FIRST_VIEW.REPORTSETTINGSNAME_TO_VIEWTYPE[config.baseReportName];
		return $http.put(URLS.host + urlPfx + globalConfig.factory.id + '/ReportSettings/SupplierScorecard', config)
			.then(updateConfigComplete)
			.catch(updateConfigFailed);

		function updateConfigComplete(response) {
			return response.data;
		}

		function updateConfigFailed(error) {
			return undefined;
		}
	}
});
